/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

/** @module components/gallery-thumbnails.js */
import baustein from "baustein";
import style from "../dom/style";
import traversal from "../dom/traversal";

var ACTIVE_CSS_CLASS = "active";
var LOADING_CSS_CLASS = "loading";
// image width plus margin
var THUMBNAIL_WIDTH = 58;
var SCROLL_DISTANCE = 2;

/**
 * @constructor
 * @alias module:components/gallery-thumbnails
 * @extends module:components/components
 */
export default baustein.register(
    "gallery-thumbnails",
    /** @lends module:components/gallery-thumbnails.prototype */
    {
        images: null,

        thumbnailCount: 0,
        displayFromIndex: 0,
        visibleProductCount: 0,

        setupEvents: function(add) {
            add("click", ".image-gallery-thumbnail", this._onThumbnailClick);
            add("click", ".image-gallery-right", this._onMoveRightClick);
            add("click", ".image-gallery-left", this._onMoveLeftClick);
        },

        init: function() {
            this.thumbnailCount = this.el.querySelectorAll(".image-gallery-thumbnail").length;
            this.updateVisibilityCount();
            this._toggleNavigationButtons();

            return this;
        },

        onInsert: function() {
            this.setGlobalHandler("resize", this._onResize);
        },

        onRemove: function() {
            this.releaseGlobalHandler("resize", this._onResize);
        },

        setSelectedIndex: function(index, isLoading) {
            var useClass = isLoading ? LOADING_CSS_CLASS : ACTIVE_CSS_CLASS;

            var loading = this.el.querySelector("." + LOADING_CSS_CLASS);
            if (loading) {
                loading.classList.remove(LOADING_CSS_CLASS);
            }
            var active = this.el.querySelector("." + ACTIVE_CSS_CLASS);
            if (active) {
                active.classList.remove(ACTIVE_CSS_CLASS);
            }
            this.el.querySelectorAll(".image-gallery-thumbnail")[index].classList.add(useClass);
        },

        /**
         * Updates the visible product count, the main container height and the button status
         */
        _onResize: function() {
            this.updateVisibilityCount();
            this.updateButtonStatus();
        },

        /**
         * Stores how many thumbnails visible based on the with of the container
         */
        updateVisibilityCount: function() {
            this.visibleProductCount = Math.floor(
                style.getPosition(this.el).width / THUMBNAIL_WIDTH
            );
        },

        /**
         * Checks if and how much we can we can move the container to the left
         */
        _onMoveRightClick: function() {
            // how many images are not visible on the right?
            var imagesLeft = this.thumbnailCount - this.displayFromIndex - this.visibleProductCount;

            if (imagesLeft > SCROLL_DISTANCE) {
                // update the distance if we have enough images to show
                this.displayFromIndex += SCROLL_DISTANCE;
            } else if (imagesLeft > 0) {
                // if we can't do the full distance move at least one if we still have one left
                this.displayFromIndex += SCROLL_DISTANCE - 1;
            }

            this._moveContainer();
        },

        /**
         * Checks if and how much we can we can move the container to the right
         */
        _onMoveLeftClick: function() {
            if (this.displayFromIndex >= SCROLL_DISTANCE) {
                // if we can do a full distance move - do it
                this.displayFromIndex -= SCROLL_DISTANCE;
            } else {
                // if not just end here
                this.displayFromIndex = 0;
            }

            this._moveContainer();
        },

        /**
         * Moves the container and updates the button status
         */
        _moveContainer: function() {
            var translate = "translate3d(-" + THUMBNAIL_WIDTH * this.displayFromIndex + "px, 0, 0)";
            style.setStyle(this.el.querySelector(".image-gallery-images"), "transform", translate);
            this.updateButtonStatus();
        },

        _toggleNavigationButtons: function() {
            this.el.classList.toggle(
                "show-navigation",
                this.thumbnailCount > this.visibleProductCount
            );
        },

        /**
         * Disables the navigation buttons if there are no images on the left or right
         */
        updateButtonStatus: function() {
            // enough images to still show the buttons?
            this._toggleNavigationButtons();
            if (!this.el.classList.contains("show-navigation") && this.displayFromIndex > 0) {
                this.displayFromIndex = 0;
                this._moveContainer();
            }

            // how many images are not visible on the right?
            var imagesLeft = this.thumbnailCount - this.displayFromIndex - this.visibleProductCount;
            var rightButton = this.el.querySelector(".image-gallery-right");
            var leftButton = this.el.querySelector(".image-gallery-left");

            if (rightButton) {
                if (imagesLeft === 0) {
                    rightButton.setAttribute("disabled", "disabled");
                } else {
                    rightButton.removeAttribute("disabled");
                }
            }

            if (leftButton) {
                if (this.displayFromIndex === 0) {
                    leftButton.setAttribute("disabled", "disabled");
                } else {
                    leftButton.removeAttribute("disabled");
                }
            }
        },

        /**
         * Prefetches the image and adds loading indication
         */
        _onThumbnailClick: function(event) {
            event.preventDefault();

            var wrapperElement = traversal.closest(event.target, ".image-gallery-thumbnail");
            if (!wrapperElement) {
                return;
            }
            this.emit("thumbnailClick", { index: wrapperElement.getAttribute("data-index") });
        }
    }
);

